import PropTypes from "prop-types"
import React from "react"

import LogoDark from "../images/logo_dark.png"

const Header = () => {
  return (
    <header className="nav">
      <div className="nav-search-wrap">
        <div className="nav-search-inner">
          <div className="nav-search-cell">
            <form method="get">
              <div className="nav-search-field-holder">
                <input
                  type="search"
                  className="nav-search-input"
                  placeholder="What are you looking for?"
                />
                <i
                  className="ui-close nav-search-close"
                  id="nav-search-close"
                ></i>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="nav-holder" id="sticky-nav">
        <div className="container">
          <div className="flex-parent">
            <div className="nav-header clearfix">
              <div className="logo-wrap">
                <a href="../pages/index.js">
                  <img
                    className="logo logo-dark"
                    src={LogoDark}
                    width="120px"
                    height="58px"
                    alt="logo"
                  />
                </a>
              </div>

              <button
                type="button"
                className="nav-icon-toggle"
                id="nav-icon-toggle"
                data-toggle="collapse"
                data-target="#navbar-collapse"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="nav-icon-toggle-bar"></span>
                <span className="nav-icon-toggle-bar"></span>
                <span className="nav-icon-toggle-bar"></span>
              </button>
            </div>
            <nav
              id="navbar-collapse"
              className="nav-wrap nav-align-right collapse navbar-collapse"
            >
              <ul className="nav-menu">
                <li role="presentation" className="active  ">
                  <a href="https://tafafricaglobal.com">Home</a>
                </li>
                <li role="presentation" className="  ">
                  <a href="https://tafafricaglobal.com/about">About</a>
                </li>
                <li role="presentation" className="  ">
                  <a href="https://tafafricaglobal.com/projects">Projects</a>
                </li>
                <li role="presentation" className="  ">
                  <a
                    href="https://taf-listing-portal.assutech.now.sh/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rentals
                  </a>
                </li>
                <li role="presentation" className="  ">
                  <a href="https://tafafricaglobal.com/gallery">Gallery</a>
                </li>
                <li role="presentation" className="  ">
                  <a href="https://tafafricaglobal.com/blog-posts">
                    Blog Posts
                  </a>
                </li>
                <li role="presentation" className="  ">
                  <a href="https://tafafricaglobal.com/contact">Contact</a>
                </li>
                <li className="nav-dropdown">
                  <a
                    style={{
                      backgroundColor: "darkred",
                      color: "#fff",
                      paddingRight: "17pt",
                    }}
                    href="{{ '/project/dalaba-estate' }}"
                  >
                    DALABA ESTATE
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}
